import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class PlatformsService {
  getPlatforms() {
    return ApiService.get(`${Config.api.auth.url}platforms`, {}).then((response) => response.data);
  }

  getPlatform(id) {
    return ApiService.get(`${Config.api.auth.url}platforms/${encodeURIComponent(id)}`, {}).then(
      (response) => response.data,
    );
  }

  // Full replace: the body must carry every field, or the missing ones are cleared.
  updatePlatform(platform) {
    return ApiService.put(`${Config.api.auth.url}platforms/${encodeURIComponent(platform.id)}`, platform).then(
      (response) => response.data,
    );
  }

  // ----- Admin -----
  getTenantPlatforms() {
    return ApiService.get(`${Config.api.auth.url}tenants/current/platforms`, {})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  setTenantPlatform({ platformAccess }) {
    return ApiService.put(
      `${Config.api.auth.url}tenants/${platformAccess.tenantId}/platforms/${platformAccess.platformId}`,
      platformAccess,
    )
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }
}

export const platformsService = new PlatformsService();
